import BriefTable from "./components/BriefTable";

function BriefList() {
  return (
    <div className="h-full flex flex-col justify-start items-start">
      <div className="h-[calc(100%-13vh)] w-full">
        <BriefTable />
      </div>
    </div>
  );
}

export default BriefList;
